<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="600px">
      <c-card class="white" :title="onDialogTitle">
        <v-form lazy-validation ref="form">
          <v-container>
            <v-row align="center">
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">결제 상황</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <v-radio-group v-model="driveLogPayFormData.payStatus" row>
                  <v-radio label="완료" value="ps_paid"></v-radio>
                  <v-radio label="완료(미수금)" value="ps_part_paid"></v-radio>
                  <v-radio label="미수금" value="ps_arrears"></v-radio>
                  <v-radio label="미완료" value="ps_unpaid"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">수금일시</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <v-menu
                  v-model="timeMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="driveLogPayFormData.extraPayTime"
                      prepend-icon="event"
                      label="수금일시"
                      readonly
                      v-on="on"
                      :disabled="isExtraPayDisable"
                    ></v-text-field>
                  </template>
                  <c-date-picker 
                    v-model="driveLogPayFormData.extraPayTime" 
                    @input="timeMenu = false" firstDayOfWeek="1" 
                    :selectedDate="driveLogPayFormData.extraPayTime"
                    :disabled="isExtraPayDisable"
                    locale="ko-kr"
                  ></c-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">입금자명</span>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <v-text-field v-model="driveLogPayFormData.extraPayCustomerName" placeholder="입금자 이름을 입력하세요" :autofocus="true" :readonly="useSameName" color="navy" :disabled="isExtraPayDisable" maxlength="32"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <v-checkbox label="예약자와 동일" v-model="useSameName" @change="toggleCustomerName" class="mr-3" dense :disabled="isExtraPayDisable"></v-checkbox>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">추가 결제 수단</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <v-select
                    dense
                    v-model="driveLogPayFormData.extraPayMethod"
                    :items="getPayMethodList"
                    item-text="configName"
                    item-value="configValue"
                    menu-props="{ offsetY: true}"
                    hide-details
                    color="navy"
                    :disabled="isExtraPayDisable"
                  ></v-select>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="ml-1 mb-2">추가 결제 금액</span>
              </v-col>
              <v-col cols="12" md="8" sm="8">
                <v-text-field v-model="driveLogPayFormData.extraPaidFee" placeholder="추가 결제 금액" :autofocus="true" color="navy" :disabled="isExtraPayDisable" maxlength="32"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <c-btn class="mr-1 mt-2" color="blue" outlined @click="onUpdateDriveLogPay">수정</c-btn>
              <c-btn class="mt-2" color="gray" outlined @click="openFlag = false">취소</c-btn>
            </v-row>
          </v-container>
        </v-form>
      </c-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import { mask } from 'vue-the-mask';

  export default {
    directives: { mask },
    props: {
      open: {
        type: Boolean,
        default: false
      },
      driveLogPayFormData: {
        type: Object,
        default: undefined
      }
    },
    data: () => ({
      openFlag: false,
      timeMenu: false,
      useSameName: false,
      isExtraPayDisable: true,
    }),
    watch: {
      open(value) {
   	    if(value && this.driveLogPayFormData) {
   	      if ( this.driveLogPayFormData.payStatus == "ps_part_paid" || this.driveLogPayFormData.payStatus == "ps_unpaid" ) {
            this.isExtraPayDisable = true;
            this.useSameName = false;
          } else {
            this.isExtraPayDisable = false;
          }
        }
        this.openFlag = value;
      },
      openFlag(value) {
        this.$emit('update:open', value);
      },
      "driveLogPayFormData.payStatus"(value) {
        if ( value == "ps_part_paid" || this.driveLogPayFormData.payStatus == "ps_unpaid" ) {
          this.isExtraPayDisable = true;
          this.driveLogPayFormData.extraPayMethod = "pm_unpaid";
          this.driveLogPayFormData.extraPayTime = null;
          this.driveLogPayFormData.extraPaidFee = 0;
          this.driveLogPayFormData.extraPayCustomerName = "";
          this.useSameName = false;
        } else {
          this.isExtraPayDisable = false;
        }
      }
    },
    computed: {
      onDialogTitle() {
        return '결제 정보 변경';
      },
      getPayMethodList() {
          return this.$store.state.config.pay_method;
      }
    },
    methods: {
      onUpdateDriveLogPay() {
        const formData = new FormData();
        formData.append("id", this.driveLogPayFormData.driveLogId);
        formData.append("extraPayMethod", this.driveLogPayFormData.extraPayMethod);
        formData.append("extraPayTime", this.driveLogPayFormData.extraPayTime);
        formData.append("payStatus", this.driveLogPayFormData.payStatus);
        formData.append("extraPaidFee", this.driveLogPayFormData.extraPaidFee);
        formData.append("extraPayCustomerName", this.driveLogPayFormData.extraPayCustomerName);
        
        this.$emit('reqUpdateDriveLogPay', formData);
      },
      toggleCustomerName() {
        if ( this.useSameName ) {
          this.driveLogPayFormData.extraPayCustomerName = this.driveLogPayFormData.customerName
        }
      }
    },
    mounted() {
      let years = [];
      let months = [];

      let thisYear = new Date().getFullYear();
      for(let i = thisYear - 100; i <= thisYear; i++) {
        years.push(i);
      }
      for(let i=1; i<13; i++) {
        months.push(i);
      }

      this.selectYears = years;
      this.selectMonths = months;
    }
  }
</script>
